var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{directives:[{name:"waves",rawName:"v-waves.green",value:(500),expression:"500",modifiers:{"green":true}}],staticClass:"wew"},[_vm._v("测试按钮")])])}
var staticRenderFns = []

export { render, staticRenderFns }